export function pad(value: number, size: number) {
	var s = value + '';
	while (s.length < size) s = '0' + s;
	return s;
}
